module.exports = __webpack_public_path__ + "static/media/unfold_less.4467a8ff.svg";